module.exports = __webpack_public_path__ + "static/media/chat-box.78bc3cfd.svg";